module.exports = __webpack_public_path__ + "img/47.e522996b.jpg";